// extracted by mini-css-extract-plugin
module.exports = {"loader":"orders_loader__3bCrQ","cardHeader":"orders_cardHeader__3Jn6-","eyeicon":"orders_eyeicon__3vvlx"};